:<template>
  <v-row>
    <v-col cols="12">
      <!-- <v-row>
        <v-col cols="12" class="text-end">
          <v-btn
            class="white--text rounded-lg"
            color="primary"
            @click="
              () =>
                $root.$emit('unitChange', {
                  isEditUnit: false,
                  propertyId: this.propertyId
                })
            "
          >
            {{ $t("landlord.addUnit") }}
          </v-btn>
        </v-col>
      </v-row> -->
      <v-dialog
        width="fit-content"
        v-model="roomNameChangeDialog"
        height="fit-content"
      >
        <v-card width="fit-content" class="px-5 py-2" height="fit-content">
          <v-card-title>
            <h4>{{ $t("core.confirmChange") }}</h4>
          </v-card-title>
          <v-card-text class="px-0">
            <div class="d-flex justify-space-around">
              <v-btn @click="updateRoomNumber" color="success">{{
                $t("core.yes")
              }}</v-btn>
              <v-btn @click="discardEditingRoom" color="error">{{
                $t("core.no")
              }}</v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-data-table
        hide-default-footer
        disable-filtering
        disable-sort
        :items="units"
        :item-class="itemClass"
        :loading="$apollo.queries.getUnitsUnderProperty.loading"
        :headers="headers"
        :no-data-text="$t('landlord.noUnits')"
      >
        <template #item.paidRent="{ item }">
          <span
            >{{ item.bookings[0].price }} {{ item.bookings[0].currency }}</span
          >
        </template>
        <template #item._id="{ item }">
          <span>{{ units.indexOf(item) + 1 }}</span>
        </template>
        <template #item.isActive="{ item }">
          <UnitDisableDialog
            isUnit
            :disabled="false"
            :id="item._id"
            :status="item.isActive"
          />
        </template>
        <template #item.edit="{ item }">
          <v-btn
            @click="
              $root.$emit('unitChange', {
                isEditUnit: true,
                propertyId: propertyId,
                unitId: item._id
              })
            "
            color="black"
            icon
          >
            <v-icon>
              mdi-pencil
            </v-icon>
          </v-btn>
        </template>
        <template #item.unitType="{ item }">
          <span class="unitName">
            {{ $vuetify.rtl ? item.unitType.nameAr : item.unitType.nameEn }}
          </span>
        </template>
        <template #item.categoryName="{ item }">
          <span class="unitName">
            {{ $vuetify.rtl ? item.nameAr : item.nameEn }}
          </span>
          <!-- <v-tooltip color="transparent" bottom>
                <template v-slot:activator="{ on, attrs }">
                </template>
                <v-img :src="BASE_URL + item.images[0]" width="200" height="150">
                </v-img>
              </v-tooltip> -->
        </template>
        <template #item.booking="{ item }">
          <v-chip
            @click="setEditingRoom(item)"
            :color="
              editingFields.roomId === item.bookings[0].roomNumberId
                ? ''
                : 'primary'
            "
          >
            <template
              v-if="editingFields.roomId === item.bookings[0].roomNumberId"
              #default
            >
              <ValidationProvider
                :rules="{ required: true }"
                ref="validateRoomNumber"
              >
                <v-text-field
                  class="pt-0 px-0"
                  rounded
                  autofocus
                  v-model="editingFields.newValue"
                  @blur="event => processBlurAndKeypressEvent(event)"
                  @keydown="event => processBlurAndKeypressEvent(event)"
                  hide-details="auto"
                >
                </v-text-field>
              </ValidationProvider>
            </template>
            <template v-else #default>
              <span>
                {{ item.bookings[0].roomNumber }}
              </span>
            </template>
          </v-chip>
        </template>
      </v-data-table>
    </v-col>
  </v-row>
</template>

<script>
import moment from "moment";
export default {
  props: {
    propertyId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      disableDialog: false,
      validityPlanDialog: false,
      roomNameChangeDialog: false,
      units: [],
      editingFields: {
        oldValue: null,
        newValue: null,
        unitId: null,
        roomId: null
      }
    };
  },
  components: {
    UnitDisableDialog: () => import("@/landlord/components/DisableDialog.vue")
  },
  computed: {
    headers() {
      return [
        {
          text: "#",
          value: "_id"
        },
        // {
        //   text: this.$t("home.category"),
        //   value: "categoryName"
        // },
        {
          text: this.$t("home.type"),
          value: "propertyType.nameEn"
        },
        {
          text: "Unit Name(En)",
          value: "nameEn"
        },
        {
          text: "Unit Name(Ar)",
          value: "nameAr"
        },
        {
          text: "Unit Number",
          value: "unitNumber"
        },
        {
          text: this.$t("landlord.rent"),
          value: "rent"
        },
        {
          text: this.$t("landlord.activeUnits"),
          value: "isActive"
        }
        // {
        //   text: this.$t("landlord.edit"),
        //   value: "edit"
        // }
      ].map(header => {
        header.width = header.width ? header.width : "10";
        header.align = "center";
        header.class = "black--text text--lighten-1 px-1";
        return header;
      });
    },
    itemClass() {
      return "text-center";
    }
  },
  created() {
    this.$root.$on("refetchUnits", () => {
      this.$apollo.queries.getUnitsUnderProperty.refetch({
        propertyId: this.propertyId
      });
    });
  },
  apollo: {
    getUnitsUnderProperty() {
      return {
        query: require("@/landlord/api/queries/get_units_under_property.graphql"),
        fetchPolicy: "no-cache",
        variables: () => ({
          input: {
            skip: 0,
            limit: 0
          },
          filter: {
            propertyId: this.propertyId
          }
        }),
        result({ data }) {
          this.units = data.getUnitsUnderProperty.units;
          console.log(data.getUnitsUnderProperty.units);
        }
      };
    }
  },
  methods: {
    moment: moment,
    addNewUnit() {
      this.$root.$emit("newUnit");
    },
    editUnit() {
      this.$root.$emit();
    },
    updateRoomNumber() {
      const selectedRoomNumberId = this.editingFields.roomId;
      const newRoomNumber = this.editingFields.newValue;
      const unitId = this.editingFields.unitId;
      this.$apollo
        .mutate({
          mutation: require("@/landlord/api/mutations/update_room_number.graphql"),
          variables: {
            unitId: unitId,
            roomId: selectedRoomNumberId,
            newRoomNumber: newRoomNumber
          }
        })
        .then(() => {
          this.discardEditingRoom();
          this.$root.$emit("refetchUnits");
        })
        .catch(error => {
          if (error.graphQLErrors[0].message) {
            this.$store.commit("SHOW_SNACKBAR", {
              color: "error",
              text: error.graphQLErrors[0].message,
              show: true
            });
            this.discardEditingRoom();
          }
        });
    },
    processBlurAndKeypressEvent(event) {
      if (event.type === "keydown") {
        if (event.key === "Escape") {
          this.discardEditingRoom();
        }
      }
      let isValid;
      this.$refs["validateRoomNumber"]
        .validate()
        .then(({ valid }) => {
          isValid = valid;
        })
        .then(() => {
          if (event.type === "blur") {
            if (isValid) {
              if (this.editingFields.oldValue !== this.editingFields.newValue) {
                this.roomNameChangeDialog = true;
              }
            }
          }
          if (event.type === "keydown") {
            if (event.key === "Enter") {
              if (isValid) {
                if (
                  this.editingFields.oldValue !== this.editingFields.newValue
                ) {
                  this.roomNameChangeDialog = true;
                }
              }
            } else {
              return event;
            }
          }
        });
    },
    setEditingRoom(item) {
      if (!item.bookings[0].isRoomBooked) {
        this.editingFields.unitId = item._id;
        this.editingFields.roomId = item.bookings[0].roomNumberId;
        this.editingFields.oldValue = item.bookings[0].roomNumber;
        this.editingFields.newValue = item.bookings[0].roomNumber;
      }
    },
    discardEditingRoom() {
      this.editingFields = {
        unitId: null,
        roomId: null,
        oldValue: null,
        newValue: null
      };
      this.roomNameChangeDialog = false;
    }
  }
};
</script>

<style>
.custom-spacing {
  gap: 3%;
}
.v-input--hide-details > .v-input__control > .v-input__slot {
  padding-right: 0px;
  padding-left: 0px;
}
.card-custom-border-radius {
  border-radius: 13px !important;
}

.card-custom-border {
  border: 1px solid #d8d7d7 !important;
}
.custom-round-button {
  height: 25px;
  width: 26px;
  border-top-left-radius: 50% !important;
  border-top-right-radius: 50% !important;
  border-bottom-right-radius: 50% !important;
  border-bottom-left-radius: 50% !important;
}
.v-application--is-ltr .v-input--selection-controls__input {
  margin-right: auto !important;
  margin-left: auto !important;
}
.unitName {
  white-space: nowrap;
}
</style>
